<template>
  <div>
    <Spinner v-if="isLoading" />

    <div class="notification is-info" v-if="subscriptionsIsEmpty">No subscriptions found.</div>

    <div class="notification is-danger" v-if="loadError">{{ loadError }}</div>

    <button
      class="button is-success is-fullwidth is-outlined add-subscription"
      v-if="!isLoading"
      @click="addSubscription()"
    >
      Add Subscription
    </button>

    <div>
      <table
        class="table is-fullwidth is-striped"
        v-if="subscriptionsLoaded && !subscriptionsIsEmpty"
      >
        <thead>
          <tr>
            <th></th>
            <th>Created At</th>
            <th>Expires</th>
            <th>Autorenews</th>
            <th>Type</th>
            <th>Platform</th>
            <th>Weight</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="subscription in subscriptions" :key="subscription.id">
            <td>
              <span class="tag is-success" v-if="subscription.isActive">active</span>

              <span class="tag is-warning" v-else-if="!subscription.isExpired">inactive</span>

              <span class="tag is-light" v-else>expired</span>
            </td>
            <td>
              <span>{{ subscription.createdAt }}</span>
            </td>
            <td>
              <span>{{ subscription.expires }}</span>
            </td>
            <td>
              <span>
                {{ subscription.autorenews }}
                <button
                  class="button is-text is-size-6 has-text-danger"
                  v-if="canCancel(subscription)"
                  @click="cancelSubscription(subscription)"
                >
                  Cancel
                </button>
                <button
                  class="button is-text is-size-6 has-text-danger"
                  v-if="canDelete(subscription)"
                  @click="deleteSubscription(subscription)"
                >
                  Delete
                </button>
              </span>
            </td>
            <td>
              <span>{{ subscriptionTypeDescription(subscription.type) }}</span>
            </td>
            <td>
              <span>{{ subscription.platform }}</span>
            </td>
            <td>
              <span>{{ subscription.weight }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <UserCancelSubscriptionModal
      v-if="subscriptionToCancel != null"
      :userStorePath="userStorePath"
      :subscription="subscriptionToCancel"
      @cancelled="closeCancelSubscriptionModal"
      @succeeded="closeCancelSubscriptionModal"
    />

    <UserDeleteSubscriptionModal
      v-if="subscriptionToDelete != null"
      :userStorePath="userStorePath"
      :subscription="subscriptionToDelete"
      @cancelled="closeDeleteSubscriptionModal"
      @succeeded="closeDeleteSubscriptionModal"
    />

    <UserAddSubscriptionModal
      v-if="showAddSubscriptionModal"
      :userStorePath="userStorePath"
      @cancelled="closeAddSubscriptionModal"
      @succeeded="closeAddSubscriptionModal"
    />
  </div>
</template>

<script>
import Spinner from '@/components/utils/Spinner'
import UserCancelSubscriptionModal from './UserCancelSubscriptionModal'
import UserDeleteSubscriptionModal from './UserDeleteSubscriptionModal'
import UserAddSubscriptionModal from './UserAddSubscriptionModal'

import {
  LOAD_SUBSCRIPTIONS,
  IS_LOADING_SUBSCRIPTIONS,
  GET_SUBSCRIPTIONS,
  GET_SUBSCRIPTIONS_LOAD_ERROR,
  HAS_EMPTY_SUBSCRIPTIONS_LOAD_RESULT
} from './userStore'

export default {
  name: 'UserSubscriptionsTab',

  components: {
    Spinner,
    UserCancelSubscriptionModal,
    UserDeleteSubscriptionModal,
    UserAddSubscriptionModal
  },

  props: {
    userStorePath: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      subscriptionToCancel: null,
      subscriptionToDelete: null,
      showAddSubscriptionModal: false
    }
  },

  mounted() {
    const loadSubscriptionsAction = `${this.userStorePath}/${LOAD_SUBSCRIPTIONS}`
    this.$store.dispatch(loadSubscriptionsAction)
  },

  methods: {
    cancelSubscription(subscription) {
      this.subscriptionToCancel = subscription
    },

    deleteSubscription(subscription) {
      this.subscriptionToDelete = subscription
    },

    addSubscription() {
      this.showAddSubscriptionModal = true
    },

    closeCancelSubscriptionModal() {
      this.subscriptionToCancel = null
    },

    closeDeleteSubscriptionModal() {
      this.subscriptionToDelete = null
    },

    closeAddSubscriptionModal() {
      this.showAddSubscriptionModal = false
    },

    canCancel(subscription) {
      return (
        subscription.isExpired == false &&
        subscription.autorenews == true &&
        subscription.platform !== 'ios' &&
        subscription.platform !== 'android'
      )
    },

    canDelete(subscription) {
      return subscription.isExpired == false
    },

    subscriptionTypeDescription(subscriptionType) {
      if (subscriptionType === 'trial') {
        return 'Trial'
      }
      if (subscriptionType === 'standard') {
        return 'Standard'
      }
      if (subscriptionType === 'premium') {
        return 'Premium'
      }
      if (subscriptionType === 'gps') {
        return 'Web GPS'
      }
      if (subscriptionType === 'gps_1') {
        return 'GPS 1 device'
      }
      if (subscriptionType === 'gps_2') {
        return 'GPS 2 devices'
      }
      if (subscriptionType === 'gps_3') {
        return 'GPS 3 devices'
      }
      if (subscriptionType === 'gps_4') {
        return 'GPS 4 devices'
      }
      if (subscriptionType === 'gps_5') {
        return 'GPS 5 devices'
      }
      if (subscriptionType === 'gps_6') {
        return 'GPS 6 devices'
      }
      if (subscriptionType === 'gps_7') {
        return 'GPS 7 devices'
      }
      if (subscriptionType === 'gps_8') {
        return 'GPS 8 devices'
      }
      if (subscriptionType === 'gps_9') {
        return 'GPS 9 devices'
      }
      if (subscriptionType === 'gps_10') {
        return 'GPS 10 devices'
      }
      if (subscriptionType === 'gps_11') {
        return 'GPS 11 devices'
      }
      if (subscriptionType === 'gps_12') {
        return 'GPS 12 devices'
      }
      if (subscriptionType === 'gps_13') {
        return 'GPS 13 devices'
      }
      if (subscriptionType === 'gps_14') {
        return 'GPS 14 devices'
      }
      if (subscriptionType === 'gps_15') {
        return 'GPS 15 devices'
      }
      if (subscriptionType === 'gps_16') {
        return 'GPS 16 devices'
      }
      if (subscriptionType === 'gps_17') {
        return 'GPS 17 devices'
      }
      if (subscriptionType === 'gps_18') {
        return 'GPS 18 devices'
      }
      if (subscriptionType === 'gps_19') {
        return 'GPS 19 devices'
      }
      if (subscriptionType === 'gps_20') {
        return 'GPS 20 devices'
      }

      return subscriptionType
    }
  },

  computed: {
    subscriptionsLoaded() {
      return this.subscriptions !== null
    },

    isLoading() {
      const isLoadingSubscriptions = `${this.userStorePath}/${IS_LOADING_SUBSCRIPTIONS}`
      return this.$store.getters[isLoadingSubscriptions]
    },

    subscriptionsIsEmpty() {
      const hasEmptySubscriptionsLoadResult = `${this.userStorePath}/${HAS_EMPTY_SUBSCRIPTIONS_LOAD_RESULT}`
      return this.$store.getters[hasEmptySubscriptionsLoadResult]
    },

    subscriptions() {
      const getSubscriptions = `${this.userStorePath}/${GET_SUBSCRIPTIONS}`
      return this.$store.getters[getSubscriptions]
    },

    loadError() {
      const getSubscriptionsLoadError = `${this.userStorePath}/${GET_SUBSCRIPTIONS_LOAD_ERROR}`
      return this.$store.getters[getSubscriptionsLoadError]
    }
  }
}
</script>

<style lang="scss" scoped>
.table td {
  border-bottom: 0;
}

td span {
  white-space: nowrap;
}

td .button {
  padding: 0px;
  margin-right: 4px;
  height: 1.5em;
}

.button.add-subscription {
  margin-bottom: 1em;
}
</style>
